/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import app from 'flarum/forum/app';
import { slug } from '../../common';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.compose`;

export default class ComposeBannerHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { banner } = this.attrs;

		return (
			<div className="ComposeBannerHero Hero IndexPageHero">
				<div className="container">
					<div className="containerNarrow">
						<h2 className="Hero-title">{t(`${prfx}.${!!banner.id() ? 'edit' : 'add'}_title`)}</h2>
						<div className="IndexPageHero-controls">
							<LinkButton
								icon="far fa-edit"
								className="Button Button--primary IndexPage-newDiscussion FacadeManagerLink"
								itemClassName="App-primaryControl"
								href={app.route('facade-manager')}
							>
								{t(`${prfx}.facade_manager`)}
							</LinkButton>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
